import 'rc-slider/assets/index.css'

import JSON_ from 'json_'
import buildUrl from 'build-url'
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {render} from 'react-dom'
import {forEach, noop} from 'lodash'
import cookie from 'cookie'
import {
  updatePowtoonContent,
  recoverPowtoonContentPromise,
  validateByLastVersion,
  initValidate
} from 'powtoon-versioning'

import Player from './Player'
import {createLogger} from './logging'
import {createViewSession, sendViewEvent, EVENTS, getISODateNow} from './services/view-events'
import mergeDynamicDataToDoc from './dynamic'
import performanceTracker from './performanceTracker'
import {getUrlVars} from  'powtoon-commons/utils'
import createDocumentFromTemplate from 'powtoon-document/utils/createDocumentFromTemplate'
import webvarsConfigurationService from 'powtoon-dashboard/src/common/services/webvarsConfigurationService'

const logger = createLogger('html-player', 'renderPlayer')
const CSRF_TOKEN = cookie.parse(document.cookie)['csrftoken']
const InitSuccessMessage = () => ({type: 'INIT_SUCCESS'})
const PlayerReadyMessage = (duration) => ({type: 'PLAYER_READY', duration})
const ReportIsPowtoonEndMessage = (isPowtoonEnd) => ({type: 'REPORT_IS_POWTOON_END', isPowtoonEnd})
const performanceFetchDocument =
'player page - fetchDocument mergeDynamicDataToDoc updatePowtoonContent recoverPowtoonContent'
///
/// we use the renderPlayer.js when html-player is used inside the iframe ,
///  BE will pass in the URL all parameters we need to render in the corect way
/// including the powtoon id ,dynamic properties and the corePlayer url
/// the renderPlayer use and call the html-player/src/player
///
function api(url, {
  method = 'GET',
  body,
  headers,
  processJsonResponse = true,
  transformResponseToCamelCase = true
} = {}) {
  const extendedHeaders = new Headers(headers)
  extendedHeaders.append('x-session', webvarsConfigurationService.getWebVar('sessionId'))
  const options = {
    method,
    body,
    headers: extendedHeaders,
    ...(window.location.hostname === 'localhost' ? {} : {credentials: 'include'})
  }

  return fetch(url, options)
    .then(response => transformResponseToCamelCase ? response.text() : response.json())
    .then(rawData => processJsonResponse && transformResponseToCamelCase ? JSON_.parse(rawData) : rawData)
    .catch(err => logger.error(err))
}

class PlayerIFrame extends Component {
  constructor(props) {
    super(props)
    this.playerRef = null

    const urlVars = getUrlVars()
    const {
      powtoon, version, hostname, force_allow_fullscreen, dynamic_id, dyn_data, dyn_rec,
      hmac, backend_key, enable_view_events, public_link_token, core_player_version, media_type, id,
      user_id_short_live_token
    } = urlVars

    this.powtoonVersion = version
    this.host = hostname
    this.dynamicRecord = dyn_rec || dynamic_id
    this.dynamicData = dyn_data
    this.hmac = hmac
    this.forceAllowFullscreen = !!force_allow_fullscreen
    this.backendKey = backend_key
    this.publicLinkToken = public_link_token
    this.userIdShortLiveToken = user_id_short_live_token
    this.viewEventsEnabled =
      enable_view_events && parseStringToBoolean(enable_view_events) &&
      (!!this.dynamicData || !!this.dynamicRecord)
    this.docId = id || powtoon
    this.hasDynamicData = !!this.dynamicData || !!this.dynamicRecord
    this.core_player_version = core_player_version

    if (media_type === 'company-template') {
      this.loadCompanyTemplateData(id)
      initValidate()
    }

    else if (media_type === 'powtoon' || powtoon) {
      const powtoonId = media_type === 'powtoon' ? id : powtoon
      this.loadDocumentData(powtoonId)
      initValidate()
    }
  }

  static propTypes = {
    onPlayerReady: PropTypes.func.isRequired,
    onTimeChange: PropTypes.func.isRequired,
    onEnd: PropTypes.func.isRequired
  }

  state = {
    doc: null,
    permissions: null,
    slideshowMode: false,
    autoplay: false,
    hideControls: false,
    watermarkOnExport: null,
    initialCaptionLocale: null,
    locales: undefined
  }

  host = null
  viewEventsEnabled = false
  powtoonLoadStarts = null
  maxPlayTime = null

  componentDidMount() {
    const urlVars = getUrlVars()
    const {nocontrols, slideshow, autoplay, watermark} = urlVars

    this.setState({
      hideControls: !!nocontrols,
      slideshowMode: !!slideshow,
      autoplay: !!autoplay,
      watermarkOnExport: watermark,
      doc: null,
      permissions: null
    })

    if (this.viewEventsEnabled) {
      this.powtoonLoadStarts = getISODateNow()
      window.addEventListener('beforeunload', this.handleWindowUnload)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleWindowUnload)
  }

  getPowtoonUrl(docId, {includePermissions, includeContent, includeExports}) {
    let url = window.POWTOON_URL
      .replace('{host}', this.host)
      .replace('{id}', docId)
    const params = {}

    if (this.dynamicRecord) {
      params.dyn_rec = this.dynamicRecord
    }
    if (this.dynamicData) {
      params.dyn_data = this.dynamicData
      if (this.hmac){
        params.hmac = this.hmac
      }
    }

    if (includePermissions) {
      url += '/permissions'
    } else if (includeExports) {
      url += '/exports'
    } else if (includeContent) {
      params.include_content = true

      if (this.dynamicRecord || this.dynamicData) {
        url +='/dynamic'
      }
    }

    if (this.powtoonVersion) {
      params.version = this.powtoonVersion
    }

    if (this.backendKey) {
      params.backend_key = this.backendKey
    }

    if (this.publicLinkToken) {
      params.public_link_token = this.publicLinkToken
    }

    if (this.userIdShortLiveToken) {
      params.user_id_short_live_token = this.userIdShortLiveToken
    }

    const powtoonUrl = buildUrl(url, {
      queryParams: params
    })
    return encodeURI(powtoonUrl)
  }

  createViewSession = () => {

    if (!this.viewEventsEnabled) {
      return
    }

    let sessionData = {
      client_time_zone: new Date().getTimezoneOffset(),
      powtoon_duration: this.state.doc.content.powtoon.slides.reduce((duration, slide) => duration+slide.duration, 0)
    }

    if (this.dynamicData) {
      const {context, recipient, time} = JSON.parse(atob(this.dynamicData))
      sessionData = {
        ...sessionData,
        context, recipient, time
      }
    }

    if (this.dynamicRecord) {
      sessionData = {
        ...sessionData,
        dyn_rec: this.dynamicRecord
      }
    }

    createViewSession(this.host, this.docId, sessionData)
      .then(() => sendViewEvent({[EVENTS.POWTOON_REQUESTED]: this.powtoonLoadStarts}, {forceSend: true}))
      .catch(noop)
  }

  fetchExportsData = async docId => {
    const url = this.getPowtoonUrl(docId, {includeExports: true})
    const exportsArray = await api(url)
    const currentExport = exportsArray.find(exportData => exportData.version === this.powtoonVersion)
  
    if (currentExport?.playerPageProps) {
      this.setState({
        initialCaptionLocale: currentExport.playerPageProps.defaultSelectedCaptions,
        locales: currentExport.playerPageProps.captionLocales
      })
    }
  }

  loadDocumentData(docId) {
    Promise.all([
      this.fetchDocument(docId),
      this.fetchPermissions(docId),
      this.fetchExportsData(docId)
    ]).then(this.createViewSession)
  }

  loadCompanyTemplateData(id) {
    const companyTemplatePath = `${this.host}/api/v2/org/library/template-items/${id}?include_content=true`
    const permissionsPath = `${this.host}/api/v2/user/me/permissions`
    Promise.all([api(companyTemplatePath), api(permissionsPath)]).then(([templateData, permissions]) => {
      const doc = createDocumentFromTemplate(templateData)
      this.setState({doc, permissions})
    })
  }

  fetchPermissions = docId => {
    const url = this.getPowtoonUrl(docId, {includePermissions: true})
    return api(url)
      .then(permissions => this.setState({permissions}))
  }

  expandManifest = (docId, manifest, additionalData) => {
    const url = `${this.host}/api/v2/manifest?powtoon_id=${docId}`
    const body = JSON.stringify({...additionalData, manifest})
    const headers = new Headers()

    headers.append('Content-Type', 'application/json')
    headers.append('Accept', 'application/json')
    headers.append('X-CSRFToken', CSRF_TOKEN)
    return api(url, {method: 'POST', body, headers, transformResponseToCamelCase: false})
  }

  fetchDocument =  docId => {
    this.performanceMeasureFetchDocument = performanceTracker.operationMeasurement({
      operationLabel: performanceFetchDocument,
      performanceEventID: null
    })
    const url = this.getPowtoonUrl(docId, {includeContent: true})
    return api(url, {processJsonResponse: false})
      .then(rawData => {
        const data = JSON.parse(rawData)
        const camelCaseData = JSON_.parse(rawData)
        return {
          ...camelCaseData,
          content: data.content,
          dynamic_data: data.dynamic_data
        }
      })
      .then(doc => this.hasDynamicData ? mergeDynamicDataToDoc(doc) : doc)
      .then(doc => updatePowtoonContent(doc.content).then(content => ({...doc, content})))
      .then(async doc => {
        const validationErrors = await validateByLastVersion(doc.content.powtoon)

        if (validationErrors === null) {
          return doc
        }
        return recoverPowtoonContentPromise(
          docId,
          doc.content,
          {logger, expandManifestService: this.expandManifest}
        ).then(({recoveredContent}) => ({
          ...doc,
          content: recoveredContent
        }))

      })
      .then(doc => {this.setState({doc: {
        ...doc,
        metadata: null,  // the metadata serves the studio only
        dynamic_data: null
      }})
      this.performanceMeasureFetchDocument()
      })

    //initValidate()
  }

  setPlayerRef = (playerRef) => {
    this.playerRef = playerRef
  }

  dispatchWindowEvents = window.parent.dispatchEvent.bind(window.parent)

  getMaxPlayTimeSec = () => Math.floor(this.maxPlayTime * 1000) / 1000

  handlePlayerReady = () => {
    sendViewEvent({[EVENTS.POWTOON_READY]: getISODateNow()})
    this.props.onPlayerReady()
  }

  handlePlay = () => {
    sendViewEvent({[EVENTS.PLAYBACK_STARTED]: getISODateNow()})
  }

  handleTimeChange = (currentTime) => {
    if (currentTime > this.maxPlayTime) {
      this.maxPlayTime = currentTime
    }
  }

  handlePlayEnd = () => {
    sendViewEvent({
      [EVENTS.PLAYBACK_COMPLETED]: getISODateNow(),
      [EVENTS.MAX_VIEW_TIME]: this.getMaxPlayTimeSec()
    })
    this.props.onEnd()
  }

  handleLinkDisplayed = ({trackId}) => {
    sendViewEvent({[EVENTS.LINKS]: {[trackId]: {[EVENTS.LINK_DISPLAYED]: getISODateNow()}}})
  }

  handleLinkClicked = ({trackId}) => {
    sendViewEvent({[EVENTS.LINKS]: {[trackId]: {[EVENTS.LINK_CLICKED]: getISODateNow()}}})
  }

  handleWindowUnload = () => sendViewEvent({[EVENTS.MAX_VIEW_TIME]: this.getMaxPlayTimeSec()}, {forceSend: true})

  viewEventsHandlers = {
    onPlay: this.handlePlay,
    onPlayerReady: this.handlePlayerReady,
    onTotalTimeChanged: this.handleTimeChange,
    onEnd: this.handlePlayEnd,
    onLinkDisplayed: this.handleLinkDisplayed,
    onLinkClicked: this.handleLinkClicked
  }

  render() {
    const {
      doc, permissions, slideshowMode, autoplay, hideControls,
      watermarkOnExport, initialCaptionLocale, locales
    } = this.state
    const {onPlayerReady, onTimeChange, onEnd} = this.props
    if (!this.docId) {
      return <div>No Document!</div>
    }
    const playerData= doc?.content?.metadata?.playerData

    return (
      <Player
        innerRef={this.setPlayerRef}
        forceAllowFullscreen={this.forceAllowFullscreen}
        dispatchWindowEvents={this.dispatchWindowEvents}
        corePlayerVersion = {this.core_player_version}
        showSpinnerWhenLoading = {true}
        {...{doc, permissions, slideshowMode, autoplay, hideControls, watermarkOnExport, playerData}}
        {...{onPlayerReady, onTimeChange, onEnd}}
        {...(this.viewEventsEnabled ? this.viewEventsHandlers : {})}
        performanceTracker={performanceTracker}
        apiHost={this.api}
        initialCaptionLocale={initialCaptionLocale}
        locales={locales}
      />
    )
  }
}

function parseStringToBoolean(str) {
  return str.toLowerCase() === 'true'
}



const getDuration = () => iframe.playerRef.getPowtoonDuration()
const createPlayerReadyMessage = () => getDuration().then(duration => new PlayerReadyMessage(duration))
const sourceWindows = []
const postMessageToAll = message => forEach(sourceWindows, source =>
  source.postMessage(message, '*'))

let isPlayerReady = false
function onPlayerReady() {
  isPlayerReady = true
  createPlayerReadyMessage()
    .then(postMessageToAll)
}

let isEnd = false
function reportIsEnd(isPowtoonEnd) {
  if (isEnd === isPowtoonEnd) { return }

  isEnd = isPowtoonEnd
  postMessageToAll(new ReportIsPowtoonEndMessage(isPowtoonEnd))
}

const _postResponseMessage = (sourceEvent, response) => {
  const {source, data} = sourceEvent

  source.postMessage({...data, response}, '*')
}

window.onmessage = (e) => {
  const {data, source} = e

  const sendResponseMessage = res => _postResponseMessage(e, res)

  switch (data.type) {
    case 'INIT':
      sourceWindows.push(source)
      source.postMessage(new InitSuccessMessage(), '*')
      if (isPlayerReady) {
        createPlayerReadyMessage()
          .then(msg => source.postMessage(msg, '*'))
      }
      break
    case 'PLAY':
      iframe.playerRef.play().then(sendResponseMessage)
      break
    case 'PAUSE':
      iframe.playerRef.pause().then(sendResponseMessage)
      break
    case 'JUMP_TO_START':
      iframe.playerRef.jumpToStart().then(sendResponseMessage)
      break
    case 'JUMP_TO_NEXT_HOLD':
      iframe.playerRef.jumpToNextHold().then(sendResponseMessage)
      break
    case 'JUMP_TO_PREVIOUS_HOLD':
      iframe.playerRef.jumpToPreviousHold().then(sendResponseMessage)
      break
    case 'JUMP_TO_NEXT_SLIDE':
      iframe.playerRef.jumpToNextSlide().then(sendResponseMessage)
      break
    case 'JUMP_TO_PREVIOUS_SLIDE':
      iframe.playerRef.jumpToPreviousSlide().then(sendResponseMessage)
      break
    case 'SET_MOVIE_MODE':
      iframe.setState({slideshowMode: false})
      break
    case 'SET_SLIDESHOW_MODE':
      iframe.setState({slideshowMode: true})
      break
    case 'HIDE_CONTROLS':
      iframe.setState({hideControls: true})
      break
    case 'SHOW_CONTROLS':
      iframe.setState({hideControls: false})
      break
    case 'LOAD_POWTOON':
      iframe.fetchDocument(data.powtoonId)
      break
    default:
      break
  }
}

const iframe = render((
  <PlayerIFrame
    onPlayerReady={onPlayerReady}
    onTimeChange={() => reportIsEnd(false)}
    onEnd={() => reportIsEnd(true)}
  />
), document.getElementById('mainPlayer'))

export default iframe
